import React from "react";

import MinimizableWebChat from "./MinimizableWebChat";
import "./App.css";

const App = (config) => (
    <div className="App">
        <MinimizableWebChat config={config?.config}/>
    </div>
);

export default App;
